export const PREFERENCES_API_BASE = "/api/customer/preference/v1/preferences";
export const NOTIFICATIONS_PREFERENCE_ID = "marketingGlobal";
export const NOTIFICATIONS_SERVICE_ID = "marketingGlobal";
export const OPT_IN_CHANNELS = ["push", "emailAddress"];
export const EMAIL_CHANNEL = "emailAddress";
export const OPT_IN_SOURCE_REASON = "savedListsNotificationsOptIn";
export const CONSENTED_STATUS = "optedIn";

export const PREFERENCE_STATUS = {
  OPTED_IN: "opted-in",
  NOT_OPTED_IN: "not-opted-in",
  UNKNOWN: "unknown"
};
